import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';
import { UtilService } from './util';
import { pluck } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UsuarioLookupService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsruser/base`;

  constructor(
    private httpClient: HttpClient,
    protected utilService: UtilService) {
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(this.url, {params});
  }

  getObjectByValue(value: string, filtro: {}): Observable<any> {
    // tratamento para Lookup com multiselect
    if (typeof(value) === 'object'){
      filtro = {...filtro,  CUSRID_IN: value};
      let httpOptions = this.utilService.filtrosHttpOptions(filtro);
      return this.httpClient.get<any>(`${this.url}`,httpOptions).pipe(pluck('items'));
    } else {
      let httpOptions = this.utilService.filtrosHttpOptions(filtro);
      return this.httpClient.get<any>(`${this.url}/${value}`,httpOptions);
    }
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CUSRNOME'  , optional: true, gridColumns: 4, label: 'Nome'},
      {property: 'CUSRCODIGO', optional: true, gridColumns: 4, label: 'Login'},
      {property: 'CUSRID'    , optional: true, gridColumns: 4, label: 'ID'},
    ];
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CUSRID'    , label: 'Id'   , width: '15%'},
      {property: 'CUSRNOME'  , label: 'Nome' , width: '35%'},
      {property: 'CUSRCODIGO', label: 'Login', width: '15%'},
      {property: 'CUSREMAIL' , label: 'Email', width: '35%'},
    ];
  }

  getFieldFormater(value: any) {
    return `${value.CUSRID} - ${value.CUSRNOME}`;
  }

}
